import React from 'react';
import { Box, Grid, TextField } from '@mui/material';
import { connect } from 'react-redux';
import { setUser } from '../../store/actions/user';
import { useFormikContext } from 'formik';

const RoleMenu = () => {
    const formik = useFormikContext();
    const [isStudent, setIsStudent] = React.useState(false);

    React.useEffect(() => {
        const newValue = (formik.values.role).toLowerCase();
        setIsStudent(newValue.includes('school') || newValue.includes('student'));
    }, [formik.values.role]);

    return (
        <Box id="Work-menu-id">
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="organization"
                        label={isStudent ? 'School Name' : 'Organization Name'}
                        onChange={formik.handleChange("organization")}
                        variant="outlined"
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="department"
                        label="Department"
                        onChange={formik.handleChange("department")}
                        variant="outlined"
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="medicalId"
                        label="Medical/Student/Employee I.D."
                        onChange={formik.handleChange("medicalId")}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="site"
                        label="Site Name"
                        onChange={formik.handleChange("site")}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="group"
                        label="Group Name"
                        onChange={formik.handleChange("group")}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        userUpdate: (user) => dispatch(setUser(user)),
    };
};

export default connect(null, mapDispatchToProps)(RoleMenu);
